<template>
  <div>
    <OpaModal width="900" height="540" v-model="value" header="Novo Banner">
      <div style="height:370px;overflow:auto; padding:20px;">
        <table>
          <tr v-if="inputBanner.type !== 'out_of_range'">
            <td>Ordem:</td>
            <td colspan="2"><input type="number" class="inputWire" style="border:1px solid #ffffff;color:#ffffff; width: 50px" v-model.number="inputBanner.order"></td>
          </tr>
          <tr style="height: 104px;">
            <td>Adicionar Link:</td>
            <td>
              <select v-model="selectModal" @change="onSelectModal">
                <option value="Choose" disabled selected>
                  Escolher
                </option>
                <option value="Product">
                  Escolher Produto
                </option>
                <option value="Category">
                  Escolher Categoria
                </option>
                <option value="Page">
                  Escolher Página
                </option>
                <option value="External">
                  Escolher Página Externa
                </option>
              </select>
            </td>
            <td>
              <div v-if="selectModal === 'External' || inputBanner.external_link !== null " style="text-decoration:underline;cursor:pointer;">
                <input type="url" placeholder="https://www.google.com.br" v-model="inputBanner.external_link">
              </div>
              <div v-else-if="inputBanner.call_to_action && inputBanner.call_to_action.includes('\/product\/')" @click="selectProductModal=true" style="text-decoration:underline;cursor:pointer;">
                {{inputBanner.call_to_action}}
              </div>
              <div v-else-if="selectModal === 'Category' || inputBanner.call_to_action && inputBanner.call_to_action.includes('\/categories\/')" @click="selectCategoriesModal=true" style="text-decoration:underline;cursor:pointer;">
                {{inputBanner.call_to_action}}
              </div>
              <div v-else-if="selectModal === 'Page' || inputBanner.call_to_action && !inputBanner.call_to_action.includes('\/categories\/'||'\/product\/')" @click="selectPagesModal=true" style="text-decoration:underline;cursor:pointer;">
                {{inputBanner.call_to_action}}
              </div>
              <div v-if="inputBanner.call_to_action" style="text-decoration:underline;cursor:pointer;" @click="delete inputBanner.call_to_action; $forceUpdate()">
                remover link
              </div>
              <div v-else-if="inputBanner.external_link && inputBanner.type === 'out_of_range'" style="text-decoration:underline;cursor:pointer;" @click="delete inputBanner.external_link; $forceUpdate()">
                remover link
              </div>
            </td>
          </tr>
          <tr>
            <td>Imagem<br/>450 x 300:</td>
            <td style="height:300px;">
              <OpaDragImage @uploadImage="(image) => saveImageNewBanner(image, 'xs_url')"/>
            </td>
            <td>
              <img v-if="inputBanner.xs_url" :src="getImage(inputBanner, 'xs_url') " style="max-width:400px;">
            </td>
          </tr>
          <tr>
            <td>Imagem<br/>900 x 400:</td>
            <td style="height:300px;">
              <OpaDragImage @uploadImage="(image) => saveImageNewBanner(image, 'sm_url')"/>
            </td>
            <td>
              <img v-if="inputBanner.sm_url" :src="getImage(inputBanner, 'sm_url') " style="max-width:400px;">
            </td>
          </tr>
          <tr>
            <td>Imagem<br/> 1330 x 500:</td>
            <td style="height:300px;">
              <OpaDragImage @uploadImage="(image) => saveImageNewBanner(image, 'md_url')"/>
            </td>
            <td>
              <img v-if="inputBanner.md_url" :src="getImage(inputBanner, 'md_url') " style="max-width:400px;">
            </td>
          </tr>
        </table>
      </div>
      <div class="modal_footer">
        <button class="buttonFlat" style="width:80px;float:right;margin:20px;margin-right:20px;" @click="saveBanner(); selectModal = 'Choose'">Salvar</button>
        <button class="buttonWire" style="width:80px;float:right;margin:20px;margin-right:0px;" @click="$emit('close'); selectModal = 'Choose'">Cancelar</button>
      </div>
    </OpaModal>
    <OpaSelectProduct v-model="selectProductModal" :previousSelectedIds="getSelectedProductIds()" :single="true" @close="selectProductModal=false;selectModal = 'Choose'" @selectProduct="(e) => selectProduct(e)"/>
    <OpaSelectCategories v-model="selectCategoriesModal" :previousSelectedIds="getSelectedCategoriesIds()" :single="true" @close="selectCategoriesModal=false;selectModal = 'Choose'" @selectCategory="(e) => selectCategory(e)"/>
    <OpaSelectPages v-model="selectPagesModal" :previousSelectedNames="getSelectedPageNames()" :single="true" @close="selectPagesModal=false;selectModal = 'Choose'" @selectPages="(e) => selectPage(e)"/>
  </div>
</template>

<script>
  import OpaModal from '@/components/OpaModal.vue'
  import OpaDragImage from '@/components/OpaDragImage.vue'
  import OpaSelectProduct from '@/components/OpaSelectProduct.vue'
  import OpaSelectCategories from '@/components/OpaSelectCategories.vue'
  import OpaSelectPages from '@/components/OpaSelectPages.vue'
  import {EventBus} from '@/utils/event-bus'
  import axios from 'axios'
  import {mapGetters} from 'vuex'

  export default {
    name: 'OpaImg',
    props: [
      "value",
      "inputBanner",
    ],

    data() {
      return {
        modalBanner: true,
        selectProductModal: false,
        selectCategoriesModal: false,
        selectPagesModal: false,
        selectModal: 'Choose'
      }
    },

    components: {
      OpaModal,
      OpaSelectProduct,
      OpaSelectCategories,
      OpaSelectPages,
      OpaDragImage
    },

    methods: {
      ...mapGetters(['getAdmin', 'getCompany', 'getOpaApi']),

      saveBanner() {
        this.inputBanner.typeLink = this.selectModal
        this.$emit('saveBanner', this.inputBanner)
      },

      onSelectModal() {
        if (this.selectModal === 'Product') {
          this.selectProductModal = true
        } else if (this.selectModal === 'Category') {
          this.selectCategoriesModal = true
        } else if (this.selectModal === 'Page') {
          this.selectPagesModal = true
        } else if (this.selectModal === 'External') {
          this.selectModal = 'External'
        } else {
          EventBus.$emit('showAlert', 'error', 'Erro ao selecionar tipo de link')
        }
      },

      selectProduct(productId) {
        if (this.inputBanner) {
          this.inputBanner.external_link = null
          this.inputBanner.call_to_action = '/product/' + productId
        }
      },

      getSelectedProductIds() {
        if (this.inputBanner && this.inputBanner.call_to_action) {
          return [this.inputBanner.call_to_action.replace('/product/', '')]
        } else {
          return []
        }
      },

      selectCategory(categoryId) {
        if (this.inputBanner) {
          this.inputBanner.external_link = null
          this.inputBanner.call_to_action = '/categories/' + categoryId
        }
      },

      getSelectedCategoriesIds() {
        if (this.inputBanner && this.inputBanner.call_to_action) {
          return [this.inputBanner.call_to_action.replace('/categories/', '')]
        } else {
          return []
        }
      },

      selectPage(PageName) {
        if (this.inputBanner) {
          this.inputBanner.external_link = null
          this.inputBanner.call_to_action = '/' + PageName
        }
      },

      getSelectedPageNames() {
        if (this.inputBanner && this.inputBanner.call_to_action) {
          return [this.inputBanner.call_to_action.replace('/', '')]
        } else {
          return []
        }
      },

      getImage(banner, size) {
        return 'https://' + this.getCompany().Id + '/img/' + this.getCompany().companyId + '/banner/' + banner[size]
      },

      saveImageNewBanner(file, size) {
        console.log('NEW FILE => ', file, size)
        let vm = this
        let bodyFormData = new FormData()
        bodyFormData.append('file', file)
        EventBus.$emit('showLoading', true)
        axios({
          method: 'post',
          url: this.getOpaApi() + '/files/company/' + this.getCompany().companyId + '/banner',
          data: bodyFormData,
          config: {headers: {'Content-Type': 'form-data'}}
        })
          .then(function (response) {
            console.log('banner file', response.data)
            vm.inputBanner[size] = response.data.file_name
            EventBus.$emit('showLoading', false)
          })
          .catch(function (response) {
            console.log(response)
            EventBus.$emit('showLoading', false)
            EventBus.$emit('showAlert', 'error', 'erro ao subir imagem')
          })
      },

      updateBannerData(banner) {
        let vm = this
        axios.put(this.getOpaApi() + '/company/banner/' + this.getCompany().Id, banner)
          .then((response) => {
            vm.$store.commit('setCompany', response.data)
            EventBus.$emit('showLoading', false)
            EventBus.$emit('showAlert', 'success', 'banner atualizado')
          })
          .catch((e) => {
            console.log('ERROR', e)
            EventBus.$emit('showLoading', false)
            EventBus.$emit('showAlert', 'error', 'erro ao atualizar banner')
          })
      }
    }
  }
</script>

<style lang="scss" scoped>
  input[type='file'] {
    display: none;
  }

  label {
    cursor: pointer;
    text-decoration: underline;
  }
</style>
